export default __webpack_public_path__ + "static/media/i-need-org-id.bea8ca47.svg";